import { redirect } from 'react-router-dom';

import store from '../store';
import { getDisabledPlatformFeatureRedirect, selectPlatformRouteFlags } from './platformConfigurationUi';

export const platformFeatureRouteLoader = () => {
    const state = store.getState();
    if (state.config.platformConfigurationStatus !== 'loaded' && !state.config.platformConfiguration) {
        return null;
    }

    const flags = selectPlatformRouteFlags(state);
    const path = `${window.location.pathname}${window.location.search}`;
    const redirectTo = getDisabledPlatformFeatureRedirect(path, flags, {
        isLoggedIn: state.context.isLoggedIn
    });

    if (redirectTo && redirectTo !== window.location.pathname) {
        return redirect(redirectTo);
    }

    return null;
};
